var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFullscreenOff = function SvgFullscreenOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 13.5v7h-1v-5.294l-5.146 5.148-.708-.708L9.292 14.5H4v-1h7zm3-9v5.292l5.146-5.146.708.708-5.148 5.146H20v1h-7v-7h1z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
};
export default SvgFullscreenOff;